<template>
  <BaseAction :action="action">
    <span>
      Fix profile irregularity
    </span>
  </BaseAction>
</template>

<script>
// Components
import BaseAction from '@/components/candidate/action_items/BaseAction'

// Helpers
import _ from 'lodash'

// Vue Component
export default {
  components: { BaseAction },
  props: { action: Object },
}
</script>
